(function(){
  function initHero(root){
    if(root.__mt)return;root.__mt=true;
    var track=root.querySelector('.mt-hero__track');
    var slides=root.querySelectorAll('.mt-slide');
    var dots=root.querySelectorAll('.mt-hero__dot');
    var n=slides.length,i=0,timer;
    if(n<2)return;
    function go(k){
      i=(k+n)%n;
      track.style.transform='translateX(-'+(i*100)+'%)';
      dots.forEach(function(d,j){d.classList.toggle('is-active',j===i);});
    }
    function stop(){clearInterval(timer);}
    function play(){stop();timer=setInterval(function(){go(i+1);},6000);}
    var prev=root.querySelector('[data-mt-prev]');
    var next=root.querySelector('[data-mt-next]');
    if(prev)prev.addEventListener('click',function(){go(i-1);play();});
    if(next)next.addEventListener('click',function(){go(i+1);play();});
    dots.forEach(function(d,j){d.addEventListener('click',function(){go(j);play();});});
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',play);
    var x0=null;
    root.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    root.addEventListener('touchend',function(e){
      if(x0===null)return;
      var dx=e.changedTouches[0].clientX-x0;
      if(Math.abs(dx)>40){go(i+(dx<0?1:-1));play();}
      x0=null;
    });
    go(0);play();
  }
  function initScroller(root){
    if(root.__mts)return;root.__mts=true;
    var list=root.querySelector('.mt-scroller__list');
    if(!list)return;
    var prev=root.querySelector('[data-mt-sprev]');
    var next=root.querySelector('[data-mt-snext]');
    function step(){return list.clientWidth*0.9;}
    if(prev)prev.addEventListener('click',function(){list.scrollBy({left:-step(),behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){list.scrollBy({left:step(),behavior:'smooth'});});
  }
  function initReveal(scope){
    var els=[].slice.call(scope.querySelectorAll('.mt-reveal'));
    if(!('IntersectionObserver' in window)||(window.Shopify&&window.Shopify.designMode)){
      els.forEach(function(e){e.classList.add('is-visible');});
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){en.target.classList.add('is-visible');io.unobserve(en.target);}
      });
    },{threshold:0.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e,idx){e.style.transitionDelay=(Math.min(idx%6,5)*60)+'ms';io.observe(e);});
  }
  function initMobileNav(){
    if(document.querySelector('.mt-bottom-nav'))return;
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    if(document.querySelector('.product-form__submit'))document.body.classList.add('mt-is-product');
    var st='fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
    var icons={
      home:`<svg viewBox='0 0 24 24' ${st.replace(/"/g,"'")}><path d='M3 11l9-8 9 8'/><path d='M5 10v10h14V10'/></svg>`,
      grid:`<svg viewBox='0 0 24 24' ${st.replace(/"/g,"'")}><rect x='3' y='3' width='7' height='7' rx='1'/><rect x='14' y='3' width='7' height='7' rx='1'/><rect x='3' y='14' width='7' height='7' rx='1'/><rect x='14' y='14' width='7' height='7' rx='1'/></svg>`,
      search:`<svg viewBox='0 0 24 24' ${st.replace(/"/g,"'")}><circle cx='11' cy='11' r='7'/><path d='m21 21-4.3-4.3'/></svg>`,
      cart:`<svg viewBox='0 0 24 24' ${st.replace(/"/g,"'")}><circle cx='9' cy='20' r='1.5'/><circle cx='18' cy='20' r='1.5'/><path d='M2 3h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 7H6'/></svg>`
    };
    var items=[['Ballina',root,'home'],['Kategorit\u00eb',root+'collections','grid'],['K\u00ebrko',root+'search','search'],['Shporta',root+'cart','cart']];
    var nav=document.createElement('nav');
    nav.className='mt-bottom-nav';
    nav.setAttribute('aria-label','Navigimi');
    var html='';
    items.forEach(function(it){
      var path=location.pathname;
      var active=(it[1]===root)?(path===root||path===root.replace(/\/$/,'')):(path.indexOf(it[1])===0);
      html+=`<a href='${it[1]}' class='${active?'is-active':''}'>${icons[it[2]]}<span>${it[0]}</span>${it[2]==='cart'?"<span class='mt-count' hidden></span>":''}</a>`;
    });
    nav.innerHTML=html;
    document.body.appendChild(nav);
    fetch(root+'cart.js').then(function(r){return r.json();}).then(function(c){
      var el=nav.querySelector('.mt-count');
      if(el&&c.item_count>0){el.textContent=c.item_count;el.hidden=false;}
    }).catch(function(){});
  }
  function initStickyCta(){
    var add=document.querySelector('.product-form__submit');
    if(!add||document.querySelector('.mt-sticky-cta'))return;
    var buy=document.querySelector('[data-buy-now]');
    var bar=document.createElement('div');
    bar.className='mt-sticky-cta';
    bar.innerHTML=`<button type='button' class='mt-add'>Shto n\u00eb shport\u00eb</button>${buy?"<button type='button' class='mt-buy'>Bli tani</button>":''}`;
    document.body.appendChild(bar);
    bar.querySelector('.mt-add').addEventListener('click',function(){add.click();});
    var b=bar.querySelector('.mt-buy');
    if(b)b.addEventListener('click',function(){buy.click();});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        var gone=!en[0].isIntersecting&&en[0].boundingClientRect.top<0;
        bar.classList.toggle('is-visible',gone);
      },{threshold:0}).observe(add);
    }
  }
  function initAll(scope){
    scope=scope||document;
    scope.querySelectorAll('[data-mt-hero]').forEach(initHero);
    scope.querySelectorAll('[data-mt-scroller]').forEach(initScroller);
    initReveal(scope);
    initMobileNav();
    initStickyCta();
  }
  if(document.readyState!=='loading')initAll();
  else document.addEventListener('DOMContentLoaded',function(){initAll();});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();
